import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import styles from '../styles/variables.scss';

export class RatingTotal extends React.Component {
  componentWillReceiveProps() {
    this.calculateTotal();
  }

  calculateTotal() {
    return _.reduce(this.props.fields, (total, next) => total + (Number(next ? next.rating : 0) || 0), 0);
  }

  render() {
    return (
      <React.Fragment>
        <div id="rating-total-container">
          <div id="label">
            Total {_.startCase(this.props.type)} Track Rating
          </div>
          <div id="rating">{this.calculateTotal()}</div>
        </div>

        <style jsx>{`
          #rating-total-container {
            display: flex;
            justify-content: flex-end;
            color: ${styles.offwhite};
            margin-bottom: 1em;
            align-items: center;
          }

          #rating {
            border: 1px solid ${styles.lighterGrey};
            padding: 5px 15px;
            margin-left: 1em;
          }
        `}</style>
      </React.Fragment>
    );
  }
}

export const mapStateToProps = state => ({
  fields: _.get(state, 'form.rating.fields'),
});

export default connect(
  mapStateToProps,
)(RatingTotal);

RatingTotal.propTypes = {
  type: PropTypes.oneOf(['on', 'off', 'simulator']).isRequired,
};
